import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Navbar.css';

const Navbar: React.FC = () => {
  const navigate = useNavigate();
  return (
    <nav className="navbar">
      <div className="navbar-logo">AuditAI</div>
      <ul className="navbar-menu">
        <li>解决方案</li>
        <li>产品服务</li>
        <li>关于我们</li>
        <li>新闻资讯</li>
        <li>联系我们</li>
      </ul>
      <button className="navbar-btn" onClick={() => navigate('/consult')}>免费咨询</button>
    </nav>
  );
};

export default Navbar; 